import { render, staticRenderFns } from "./future_chance.vue?vue&type=template&id=a114e008&scoped=true&lang=pug&"
import script from "./future_chance.vue?vue&type=script&lang=js&"
export * from "./future_chance.vue?vue&type=script&lang=js&"
import style0 from "./future_chance.vue?vue&type=style&index=0&id=a114e008&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a114e008",
  null
  
)

export default component.exports